module.exports = __webpack_public_path__ + "media/images/gma-4d7f6ed9b9dfc40100cd174b9138976d.svg";